import React from "react";

// Self-hosted logo assets (no third-party CDN). See /app/frontend/public/branding/.
const LOGO_DARK = "/branding/operon-logo-dark.png";
const LOGO_LIGHT = "/branding/operon-logo-light.png";

export function OperonLogo({ theme = "dark", size = 36, withText = false, customLogo = null, companyName = null }) {
  // In light mode, if company has custom logo, use it
  if (theme === "light" && customLogo) {
    return (
      <div className="flex items-center gap-3">
        <img
          src={customLogo}
          alt={companyName || "Logo"}
          style={{ height: size, width: "auto", objectFit: "contain" }}
          className="rounded-md"
          data-testid="custom-company-logo"
        />
      </div>
    );
  }
  const src = theme === "dark" ? LOGO_DARK : LOGO_LIGHT;
  return (
    <div className="flex items-center gap-2" data-testid="operon-logo">
      <img
        src={src}
        alt="Operon"
        style={{ height: size, width: "auto", objectFit: "contain" }}
      />
      {withText && <span className="sr-only">Operon</span>}
    </div>
  );
}

export { LOGO_DARK, LOGO_LIGHT };
